import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'default' | 'outline';
  size?: 'default' | 'large' | 'small';
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'default',
  size = 'default',
  className = '',
  onClick
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all focus:outline-none focus:ring-2 focus:ring-[#00E0FF]/50 focus:ring-offset-2 focus:ring-offset-[#111]';
  const variantStyles = {
    default: 'bg-[#00E0FF] text-black hover:bg-[#00E0FF]/90 active:bg-[#00E0FF]/80 shadow-[0_0_10px_rgba(0,224,255,0.3)]',
    outline: 'bg-transparent border border-[#00E0FF]/50 text-[#00E0FF] hover:bg-[#00E0FF]/10 active:bg-[#00E0FF]/20'
  };
  const sizeStyles = {
    small: 'text-xs px-3 py-1',
    default: 'text-sm px-4 py-2',
    large: 'text-base px-6 py-3'
  };
  return <button className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} onClick={onClick} data-id="element-184">
      {children}
    </button>;
}